<ng-container>
    <reservation-countdown
        [reservedSeconds]="remainingSeconds()"
        (onCountdownEnd)="countdownEnd($event)"
    />
    <ng-container *ngIf="iframeUrl">
        <iframe #iframeElement [src]="iframeUrl | safe:'url'" frameborder="0"></iframe>
    </ng-container>
</ng-container>